//  ######   #####     ###     ####  ######
//    ##    ##   ##   ## ##   ##       ##
//    ##    ##   ##  ##   ##   ###     ##
//    ##    ##   ##  #######     ##    ##
//    ##     #####   ##   ##  ####     ##

/*
トースト通知処理
<div id="js-toast" class="md-toast"></div>
window.popToast('テキスト')
*/

const toast = document.getElementById('js-toast') // トースト要素
let popToastTimer // トーストのタイマー
const popToastTimerVal = 2500 // トーストの保持時間
let toastClass = ''
window.popToast = function (text, setClass) {
  if (!toast) {
    // トースト要素の存在確認
    return
  }
  if (setClass) {
    toastClass = setClass
  }
  toast.innerHTML = text // テキストをセット
  toast.classList.add('active')
  if (toastClass) {
    toast.classList.add(toastClass)
  }

  setTimeout(() => {
    window.cartCountUpdate() // カートのカウントを更新する
  }, 500)

  // 自動消滅までのタイマーをセット
  clearTimeout(popToastTimer)
  popToastTimer = setTimeout(function () {
    toast.classList.remove('active')
    if (toastClass) {
      toast.classList.remove(toastClass)
    }
  }, popToastTimerVal)
}
// PC時、マウスホバー中はトーストを保持する
if (toast) {
  toast.addEventListener(
    'mouseover',
    function () {
      if (window.matchMedia('(min-width:769px)').matches) {
        clearTimeout(popToastTimer)
      }
    },
    false
  )
  toast.addEventListener(
    'mouseout',
    function () {
      popToastTimer = setTimeout(function () {
        toast.classList.remove('active')
        if (toastClass) {
          toast.classList.remove(toastClass)
        }
      }, popToastTimerVal)
    },
    false
  )
}
